import { useMemo } from "react"
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { Bound } from "lib/@components/binding/Bound"
import { ComparisonTradeHeaderCell } from "./comparison-trade-header-cell"
import { ComparisonTradeBreakdownRow } from "./comparison-trade-breakdown-row"

export function ComparisonTradeBreakdown({ variants }) {
    const tradeNames = useMemo(getTradeNames, [variants])

    return (
        <TableContainer component={Box} sx={{ border: 1, borderColor: "divider", borderRadius: 1 }}>
            <Table data-cy="comparison-trade-table" size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>
                            <Typography variant="subtitle2">Trade</Typography>
                        </TableCell>
                        <Repeat list={variants} item={<ComparisonTradeHeaderCell />} />
                    </TableRow>
                </TableHead>
                <TableBody>
                    <Bound variants={variants}>
                        <Repeat list={tradeNames} item={<ComparisonTradeBreakdownRow />} pass="tradeName" />
                    </Bound>
                </TableBody>
            </Table>
        </TableContainer>
    )

    function getTradeNames() {
        const nameSet = new Set()
        for (const v of variants) {
            const trades = v?.costResult?.tradeBreakdown ?? []
            for (const t of trades) {
                if (t.tradeName) nameSet.add(t.tradeName)
            }
        }
        return [...nameSet].sort()
    }
}
